import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'app/shared/global.service';
import { UserService } from 'app/users/shared/user.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { SocketService } from 'app/shared/socket.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-full-layout',
    templateUrl: './full-layout.component.html',
    styleUrls: ['./full-layout.component.scss']
})

export class FullLayoutComponent {
    public version: string;
    public currentUser: any;
    public currentDate: Date = new Date();
    public progressCurrent: number;
    public progressTotal: number;
    public progressTitle: number;
    public progressPercent: number;
    public progressLink: number;
    public progressLinkTitle: number;

    constructor(
        private router: Router,
        private socketService: SocketService,
        private userService: UserService,
        private angularFireAuth: AngularFireAuth,
        private globalService: GlobalService) {
        this.angularFireAuth.authState.subscribe((authState: any) => {
            // this.currentUser = currentUser;
            if (authState) {
                // console.log('currentUser01', authState.uid);
                this.socketService.socket.emit('update-user-id', authState.uid);
                this.userService.getSingle(authState.uid).subscribe(user => {
                    this.currentUser = user;
                    this.globalService.updateCurrentUser(user);
                });
            } else {
                // logout
                this.router.navigate(['login']);
            }
        });
        this.globalService.version().subscribe(response => {
            this.version = response.version;
        });
        this.socketService.setupSocket();
        this.socketService.messageProgress.subscribe((data) => {
            this.progressCurrent = data.index;
            this.progressTotal = data.total;
            this.progressTitle = data.title;
            this.progressLink = data.link
            this.progressLinkTitle = data.linkTitle;
            this.progressPercent = this.progressCurrent / this.progressTotal * 100;
        });
        this.socketService.initUser.subscribe((data) => {
            console.log('initUser', this.currentUser);
            if (this.currentUser) {
                console.log('currentUser02', this.currentUser);
                this.socketService.socket.emit('update-user-id', this.currentUser.id);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full/full-layout.component.ts